import {
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
  NO_ERRORS_SCHEMA
} from '@angular/core';
import { LubbuCurrencyInputComponent } from './lubbu-currency-input/lubbu-currency-input';
import { LubbuLoaderComponent } from './lubbu-loader/lubbu-loader';
import { LubbuContentComponent } from './lubbu-content/lubbu-content';
import { LubbuAskComponent } from './lubbu-ask/lubbu-ask';
import { LubbuHeaderComponent } from './lubbu-header/lubbu-header';
import { LubbuModalHeaderComponent } from './lubbu-modal-header/lubbu-modal-header';
import { LubbuHeaderGiftComponent } from './lubbu-header-gift/lubbu-header-gift';
import { LubbuProfileComponent } from './lubbu-profile/lubbu-profile';
import { IonicModule } from 'ionic-angular';
import { LubbuIconComponent } from './lubbu-icon/lubbu-icon';
import { LoveIconComponent } from './love-icon/love-icon';
import { LoveFullIconComponent } from './love-full-icon/love-full-icon';
import { GiftIconComponent } from './gift-icon/gift-icon';
import { NewLubbuFormComponent } from './new-lubbu-form/new-lubbu-form';
import { NewLubbuIconComponent } from './icons/new-lubbu-icon/new-lubbu-icon';
import { ShareIconComponent } from './icons/share-icon/share-icon';
import { AddIconComponent } from './icons/add-icon/add-icon';
import { SportsIconComponent } from './icons/sports-icon/sports-icon';
import { TravelIconComponent } from './icons/travel-icon/travel-icon';
import { StarIconComponent } from './icons/star-icon/star-icon';
import { SearchIconComponent } from './icons/search-icon/search-icon';
import { OutdoorsIconComponent } from './icons/outdoors-icon/outdoors-icon';
import { FoodIconComponent } from './icons/food-icon/food-icon';
import { ArtIconComponent } from './icons/art-icon/art-icon';
import { FriendsIconComponent } from './icons/friends-icon/friends-icon';
import { ShoppingIconComponent } from './icons/shopping-icon/shopping-icon';
import { AnimalsIconComponent } from './icons/animals-icon/animals-icon';
import { IconsSVGComponent } from './icons/icons-svg/icons-svg';
import { SocialLoginButtonComponent } from './icons/social-login-button/social-login-button';
import { GiftCardComponent } from './gift-card/gift-card';
import { MiniGiftCardComponent } from './mini-gift-card/mini-gift-card';
import { AddAskComponent } from './add-ask/add-ask';
import { FileHelpersModule } from 'ngx-file-helpers';
import { keyboardInput } from './keyboard-input/keyboard-input';
import { IonMaskModule } from '@pluritech/ion-mask';

const modules = [
  LubbuCurrencyInputComponent,
  LubbuProfileComponent,
  LubbuLoaderComponent,
  LubbuContentComponent,
  LubbuHeaderComponent,
  LubbuModalHeaderComponent,
  LubbuHeaderGiftComponent,
  LubbuAskComponent,
  LubbuIconComponent,
  LoveIconComponent,
  LoveFullIconComponent,
  GiftIconComponent,
  NewLubbuFormComponent,
  NewLubbuIconComponent,
  ShareIconComponent,
  AddIconComponent,
  SportsIconComponent,
  TravelIconComponent,
  OutdoorsIconComponent,
  FoodIconComponent,
  ArtIconComponent,
  FriendsIconComponent,
  ShoppingIconComponent,
  AnimalsIconComponent,
  IconsSVGComponent,
  SocialLoginButtonComponent,
  StarIconComponent,
  AddAskComponent,
  SearchIconComponent,
  keyboardInput
];
@NgModule({
  declarations: [...modules, GiftCardComponent, MiniGiftCardComponent],
  imports: [IonicModule, FileHelpersModule],
  exports: [...modules, GiftCardComponent, MiniGiftCardComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class ComponentsModule {}



// WEBPACK FOOTER //
// ./src/components/components.module.ts